import { Link } from "@tanstack/react-router";
import type { PropsWithChildren } from "react";
import { Button } from "./ui/button";

export function NotFound({ children }: PropsWithChildren<unknown>) {
	return (
		<div className="w-full flex items-center justify-center flex-col gap-4 pt-20">
			<div className="text-slate-600 text-lg">
				{children || <p>The page you are looking for does not exist.</p>}
			</div>
			<p className="flex items-center gap-2 flex-wrap">
				<Button variant="secondary" onClick={() => window.history.back()}>
					Go Back
				</Button>
				<Button asChild>
					<Link to="/">Back to Home</Link>
				</Button>
			</p>
		</div>
	);
}
